import React from "react";
import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { complexDigitToman, formatMsisdn, gregorian_to_jalali, isEmpty } from "../../tools/tools";
import { useAPIDirectCharge, useAPIPublic } from "../../tools/api";
import { _adr } from "../../address";
import { Helmet } from "react-helmet";
import { LoadingPackageFactor } from "../packages/skeletonPackages";

const FactorCharge = () => {
  const { callBackDCAsanPardakht, callBackDCParsian, callBackDCIPGMellatBank } = useAPIDirectCharge();
  const { queryTaxPercent } = useAPIPublic();
  const [searchParam] = useSearchParams();
  const [tax, setTax] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [bank, setBank] = useState({
    amount: "",
    purchasedate: new Date().toISOString(),
    bankparameterone: "",
    dcmsisdn: "",
    dcpurchasefollowupcode: "",
    packagename: "",
  });

  const [isBank, setIsBank] = useState(true);
  const getTax = async () => {
    let response = null;
    response = await queryTaxPercent();
    if (response) {
      setTax(parseInt(response));
    } else {
      setTax(10);
    }
  };
  useEffect(() => {
    const checkResponse = async () => {
      await getTax();

      if (!isEmpty(searchParam.get("localInvoiceId"))) {
        let req = {
          LocalInvoiceId: searchParam.get("localInvoiceId"),
        };
        let response = await callBackDCAsanPardakht(req);
        if (response) {
          setBank({
            amount: response?.amount,
            purchasedate: response?.purchasedate,
            bankparameterone: response?.bankparameterone,
            dcmsisdn: response?.dcmsisdn,
            dcpurchasefollowupcode: response?.dcpurchasefollowupcode,
            tax: response?.tax,
          });
          setIsBank(true);
        } else {
          setIsBank(false);
          setBank({
            dcpurchasefollowupcode: req.LocalInvoiceId,
            purchasedate: new Date().toISOString(),
          });
        }
      }
      if (!isEmpty(searchParam.get("token"))) {
        let req = {
          status: searchParam.get("status"),
          token: searchParam.get("token"),
          orderId: searchParam.get("orderid"),
          terminalNo: !isEmpty(searchParam.get("terminalno")) ? searchParam.get("terminalno") : "",
          rrn: !isEmpty(searchParam.get("rrn")) ? searchParam.get("rrn") : "",
          amount: !isEmpty(searchParam.get("amount")) ? searchParam.get("amount") : "",
          swAmount: !isEmpty(searchParam.get("swamount")) ? searchParam.get("swamount") : "",
          hashCardNumber: !isEmpty(searchParam.get("hashcardnumber")) ? searchParam.get("hashcardnumber") : "",
        };
        let response = await callBackDCParsian(req);
        if (response) {
          setBank({
            amount: response?.amount,
            purchasedate: response?.purchasedate,
            bankparameterone: response?.bankparameterone,
            dcmsisdn: response?.dcmsisdn,
            dcpurchasefollowupcode: response?.dcpurchasefollowupcode,
            tax: response?.tax,
          });
          setIsBank(true);
        } else {
          setBank({
            dcpurchasefollowupcode: req.token,
            purchasedate: new Date().toISOString(),
          });
          setIsBank(false);
        }
      }
      if (!isEmpty(searchParam.get("RefId"))) {
        const payload = {
          SaleOrderId: searchParam.get("SaleOrderId") || "",
          RefId: searchParam.get("RefId") || "",
          SaleRefrenceId: searchParam.get("SaleReferenceId") || "",
          ResCode: searchParam.get("ResCode") || "",
        };
        const response = await callBackDCIPGMellatBank(payload);
        if (response) {
          setBank({
            amount: response?.amount,
            purchasedate: response?.purchasedate,
            bankparameterone: response?.bankparameterone,
            dcmsisdn: response?.dcmsisdn,
            dcpurchasefollowupcode: response?.dcpurchasefollowupcode,
            tax: response?.tax,
          });
          setIsBank(true);
        } else {
          setBank({
            dcpurchasefollowupcode: payload.RefId,
            purchasedate: new Date().toISOString(),
          });
          setIsBank(false);
        }
      }
      setIsLoading(false);
    };
    checkResponse();
  }, []);
  return (
    <>
      <Helmet>
        <title>مبلغ شارژ آپتل - فاکتور نهایی</title>
        <meta name="description" content="خرید شارژ آپتل" />
        <meta name="keywords" content="خرید شارژ آپتل" />
      </Helmet>
      <div className="packages pt-4 pb-4">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              {isLoading ? (
                <LoadingPackageFactor />
              ) : (
                <div className="holder-factor">
                  <div className="holder-icon-factor">
                    <div className="shareicon">
                      <i className="icon-share"></i>
                    </div>
                    <div className="downloadicon">
                      <i className="icon-download"></i>
                    </div>
                  </div>
                  <div className="holder-icon-status">
                    {isBank ? (
                      <div className="bg-success">
                        <i className="icon-check"></i>
                      </div>
                    ) : (
                      <div className="bg-danger">
                        <i className="icon-close"></i>
                      </div>
                    )}
                  </div>
                  <div className="holder-title-status">
                    <h2>{isBank ? <>پرداخت موفق</> : <>پرداخت ناموفق</>}</h2>
                  </div>
                  <div className="holder-list-result">
                    <ul className="list-unstyled">
                      {isBank && (
                        <li>
                          <div className="label">مبلغ شارژ</div>
                          <div className="value">
                            <span dir="ltr">{complexDigitToman(bank.amount)}</span>
                            تومان
                          </div>
                        </li>
                      )}

                      <li>
                        <div className="label">تاریخ و ساعت</div>
                        <div className="value">
                          <span dir="ltr">{gregorian_to_jalali(bank.purchasedate) + " - " + bank.purchasedate.split("T")[1].split(".")[0]}</span>
                        </div>
                      </li>

                      {isBank && (
                        <li>
                          <div className="label">مالیات بر ارزش افزوده </div>
                          <div className="value">
                            ({tax}%) &nbsp;
                            <span dir="ltr">{complexDigitToman((bank.amount * tax) / 100)}</span>
                            &nbsp; تومان
                          </div>
                        </li>
                      )}

                      <li>
                        <div className="label">نوع سرویس</div>
                        <div className="value">
                          <span dir="ltr">خرید شارژ</span>
                        </div>
                      </li>
                      {isBank && (
                        <li>
                          <div className="label">شماره سیم کارت</div>
                          <div className="value">
                            <span dir="ltr">0{formatMsisdn(bank.dcmsisdn)}</span>
                          </div>
                        </li>
                      )}
                      {bank?.dcpurchasefollowupcode.length > 0 && (
                        <li>
                          <div className="label">کد پیگیری</div>
                          <div className="value">
                            <span dir="ltr">{bank.dcpurchasefollowupcode}</span>
                          </div>
                        </li>
                      )}
                    </ul>
                  </div>
                  <div className="holder-button">
                    <Link to={_adr.Root + _adr.DirectCharge} replace={true} className="btn btn-normal">
                      بازگشت به صفحه اصلی
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FactorCharge;
